var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { detectOverflow, size } from "@floating-ui/react";
import { getAlignment, getSide, getSideAxis } from "@floating-ui/utils";
const isFlipped = (axis, initialPlacement, flippedToPlacement) => getSideAxis(initialPlacement) === axis
    ? getSide(initialPlacement) !== getSide(flippedToPlacement)
    : getAlignment(initialPlacement) !== getAlignment(flippedToPlacement);
export const isFlippedHorizontally = (initialPlacement, flippedToPlacement) => isFlipped("x", initialPlacement, flippedToPlacement);
export const isFlippedVertically = (initialPlacement, flippedToPlacement) => isFlipped("y", initialPlacement, flippedToPlacement);
export const sizeMatchRefWidth = (hasSameWidth) => size({
    apply: ({ elements, rects }) => {
        Object.assign(elements.floating.style, {
            width: hasSameWidth ? `${rects.reference.width}px` : null,
        });
    },
});
export const sizeMinRefWidth = () => size({
    apply: ({ elements, rects }) => {
        Object.assign(elements.floating.style, {
            minWidth: `${rects.reference.width}px`,
        });
    },
});
/** resets placement to initial placement if the flipped placement overflows too */
export const resetFlipIfOverflows = () => ({
    name: "resetFlipIfOverflows",
    fn(state) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (state.initialPlacement !== state.placement &&
                ((_a = state.middlewareData.flip) === null || _a === void 0 ? void 0 : _a.overflows.some((ov) => ov.placement === state.placement))) {
                return {
                    reset: {
                        placement: state.initialPlacement,
                    },
                };
            }
            return {};
        });
    },
});
export const hideWhenTargetHidden = (onTargetHidden, rightBarWidth) => ({
    name: "hideWhenTargetHidden",
    fn(state) {
        return __awaiter(this, void 0, void 0, function* () {
            const overflow = yield detectOverflow(state, {
                elementContext: "reference",
                // extend parent container boundaries when RightBar is open
                padding: { right: -(rightBarWidth || 0) },
            });
            if (Math.round(overflow.top) > 0 ||
                Math.round(overflow.bottom) > 0 ||
                Math.round(overflow.left) > 0 ||
                Math.round(overflow.right) > 1) {
                state.elements.floating.style.visibility = "hidden";
                state.elements.floating.style.pointerEvents = "none";
                onTargetHidden();
            }
            else {
                state.elements.floating.style.visibility = "inherit";
                state.elements.floating.style.pointerEvents = "inherit";
            }
            return {};
        });
    },
});
/**
 * Adjusts the x and y offsets when floating element is flipped.
 * Should be run after flip and resetFlipIfOverflows middlewares.
 *
 * When the element is flipped, floating-ui already adjust the offsets of the side axis (top/right/bottom/left),
 * so we only need to adjust the alignment (start/end) offset.
 * Example: initial placement is on the left and it flips vertically (i.e. on the alignment axis),
 * we need to adjust the y offset.
 * https://github.com/floating-ui/floating-ui/blob/master/packages/utils/src/index.ts
 */
export const adjustOffsets = () => ({
    name: "adjustOffsets",
    fn(state) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            return {
                x: state.x +
                    (isFlippedHorizontally(state.initialPlacement, state.placement) && getSideAxis(state.initialPlacement) === "y"
                        ? ((_b = (_a = state.middlewareData.offset) === null || _a === void 0 ? void 0 : _a.x) !== null && _b !== void 0 ? _b : 0) * -2
                        : 0),
                y: state.y +
                    (isFlippedVertically(state.initialPlacement, state.placement) && getSideAxis(state.initialPlacement) === "x"
                        ? ((_d = (_c = state.middlewareData.offset) === null || _c === void 0 ? void 0 : _c.y) !== null && _d !== void 0 ? _d : 0) * -2
                        : 0),
            };
        });
    },
});
//# sourceMappingURL=FloatingUtils.js.map